import { useStudyingDeckStudyCardsQueryOptions } from "@-/dev.improve.haniverse.lib.cards.read";
import { usePrefetchedSuspenseQuery } from "@-/com.npmjs.tanstack__react-query";
import { useIsActorSyncPreparing } from "@-/dev.improve.haniverse.routes.nav._context";
import { useRefetchOnTabFocus } from "@-/dev.improve.haniverse.routes.nav._lib.tab-focus-refetch";
import { ScreenReadyMarker } from "@-/dev.improve.haniverse.components.ui.screen-ready-marker";
import { DeckUpcomingPageLoadingFallback } from "#deck-upcoming-page-loading-fallback";
import { DeckTodayView } from "#deck-today-view";
import { DeckUpcomingView } from "#deck-upcoming-view";

export function DeckUpcomingPageSuspense({ today = false }: { today?: boolean } = {}) {
  // The page boundary owns the initial loading state while this suspense query resolves. On a
  // RETURN visit the tab is only frozen (not remounted), so `useRefetchOnTabFocus` re-runs the query
  // when the Decks tab regains focus. Suspense keeps the previous `data` visible during the
  // background refetch. The view below re-reads the same (cached) query through its page model.
  const { data: studyingDeckStudyCards, refetch } = usePrefetchedSuspenseQuery(
    useStudyingDeckStudyCardsQueryOptions(),
  );
  useRefetchOnTabFocus(refetch);
  const isSyncing = useIsActorSyncPreparing();

  return (
    <>
      {/* An empty deck while the first cloud pull is still preparing is "not synced yet", not
          "nothing due": keep the section skeleton up until the pull settles. */}
      {isSyncing && studyingDeckStudyCards.length === 0 ? (
        <DeckUpcomingPageLoadingFallback today={today} />
      ) : today ? (
        <DeckTodayView />
      ) : (
        <DeckUpcomingView />
      )}
      {/* Screen-render timing end mark: this component only renders once the suspense query above
          has resolved, so mounting here marks "navigated → deck data on screen" (`tti`). */}
      <ScreenReadyMarker screen="decks" />
    </>
  );
}
